<template>
  <InteractionStep
                   :has-next="false">
    <template v-slot:content>
      <div class="step-text">
        <h3 class="step-text__title">{{ $tInteraction('Click finish to complete the interaction') }}</h3>

        <button @click.prevent="onSave"
                class="step-information__btn-end  _with-post  base-btn  base-btn--blue">
          <BaseSvg name="ico-check"
                   width="1.4rem"
                   height="1.8rem"
                   style="position: relative; margin-right: 0.5rem"/>
          <span>{{ $tInteraction('Complete') }}</span>
          <BasePreloader v-if="pendingSave"/>
        </button>
      </div>
      <BaseAlert :value="error" class="step-information__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '../../../axios'
  import InteractionStep from '../InteractionStep'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    name: 'InteractionStepPassport2',
    mixins: [interactionStepMixin],
    data() {
      return {
        pendingSave: false,
        error: null,
      }
    },
    components: {
      InteractionStep
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`).then(async () => {
          await this.$router.push({name: 'account-received-resume'})
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      }
    }
  }
</script>

<style>

</style>
